import * as type from '../actions/types';

const initialState = {
    chatbox: {},
    loading: false,
    error: null,
}

export default function activateChatBox(state = initialState, action) {
    switch (action.type) {
        case type.ACTIVATE_CHATBOX_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.ACTIVATE_CHATBOX_SUCCESS:
            return {
                ...state,
                loading: false,
                chatbox: action.data,
            }
        case type.ACTIVATE_CHATBOX_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}